// extracted by extract-css-chunks-webpack-plugin
module.exports = {"panel-sub-header":"styles__panel-sub-header___BOojM","panelSubHeader":"styles__panel-sub-header___BOojM"};
    if(module.hot) {
      // 1772142930030
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  